export class CasierSummary {
    'Cash': number;
    'Cheque': number;
    'Credit/Debit Card': number;
    'Online Transfer': number;
    'Paytm': number;
    "PayU":number;
    'e-money': number;
}
